import { createFileRoute } from '@tanstack/react-router';
import { AbsenceModule } from '@/modules/ess/absence';

export const Route = createFileRoute('/(dashboard)/_dashboard/ess/absence/')({
  component: AbsenceModule,
});
